export const messageTheme = {
  colorScheme: {
    light: {
      info: {
        color: '{sd.text.primary}'
      },
      warn: {
        color: '{sd.text.primary}'
      }
    }
  }
};
